export default __webpack_public_path__ + "static/media/3.01652060.png";